<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="amzFirstDemandCode"
      border
      auto-resize
      highlight-hover-row
      resizable
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:reviewInfo="{ row }">
        <span>{{ row.reviewByName }}</span>
        <br />
        <span>{{ row.reviewTime }}</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag size="mini" effect="dark" :type="row.amzFirstDemandStatus">
          {{ row.v_amzFirstDemandStatus }}
        </el-tag>
      </template>
      <template v-slot:skuSalesChannel="{ row }">
        <el-tag
          size="mini"
          v-if="row.v_skuSalesChannel"
          :type="row.skuSalesChannel == 'V' ? 'warning' : ''"
        >
          {{ row.v_skuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true)
      this.$emit('checkboxChange', data)
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { amzFirstDemandCode = '', amzFirstDemandNo = '' } = data

      switch (menuType) {
        case 'detail':
        case 'review':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { amzFirstDemandCode },
            query: { amzFirstDemandNo },
          })
          break
        case 'reject':
          this.reject(data)
          break
      }
    },
    async submitReview({ amzFirstDemandCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_submit_review') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzFirstDemandDelApi({ amzFirstDemandCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async review({ amzFirstDemandCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_review') || '是否进行企划确认？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzFirstDemandReviewApi({ amzFirstDemandCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_audit_success') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async reject({ amzFirstDemandCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_reject') || '是否驳回该审核申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzFirstDemandRejectApi({ amzFirstDemandCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_rejected_successfully') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--S {
    color: #fa561f;
    background-color: #fff2e8;
    border: #ffbb96;
  }
  .el-tag--R {
    color: white;
    background-color: #3699fe;
    border: #007bff;
  }
  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: #ffa39e;
  }
  .el-tag--N {
    color: #6c6c6c;
    background-color: #bbbbbb;
    border-color: #bbbbbb;
  }
  .el-tag--Y {
    color: #70ce46;
    background-color: #f6ffed;
    border-color: #b7eb8f;
  }
}
</style>
